import { render, staticRenderFns } from "./kickPlayerOffline.vue?vue&type=template&id=0cf92e5a&"
import script from "./kickPlayerOffline.vue?vue&type=script&lang=js&"
export * from "./kickPlayerOffline.vue?vue&type=script&lang=js&"
import style0 from "./kickPlayerOffline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf92e5a')) {
      api.createRecord('0cf92e5a', component.options)
    } else {
      api.reload('0cf92e5a', component.options)
    }
    module.hot.accept("./kickPlayerOffline.vue?vue&type=template&id=0cf92e5a&", function () {
      api.rerender('0cf92e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/serverManagement/kickPlayerOffline.vue"
export default component.exports